import { render, staticRenderFns } from "./SubtaskRelevanceTopicModal.vue?vue&type=template&id=5b12cd1b&scoped=true&"
import script from "./SubtaskRelevanceTopicModal.vue?vue&type=script&lang=js&"
export * from "./SubtaskRelevanceTopicModal.vue?vue&type=script&lang=js&"
import style0 from "./SubtaskRelevanceTopicModal.vue?vue&type=style&index=0&id=5b12cd1b&lang=less&scoped=true&"
import style1 from "./SubtaskRelevanceTopicModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b12cd1b",
  null
  
)

export default component.exports